import { DatePipe } from '@angular/common';
import { Component, Inject, NO_ERRORS_SCHEMA } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogContent } from '@angular/material/dialog';
import { CommonModelService } from '../../../../padu-reporting/capability/common-model.service';
import { AppViewService } from '../../../../shared/services/tcm-hub-appview.service';
import { Router } from '@angular/router';
import { NgModel, FormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatInput } from '@angular/material/input';

@Component({
    selector: 'app-share-group',
    templateUrl: './share-group.component.html',
    styleUrls: ['./share-group.component.css'],
    providers: [NgModel],
    imports: [MatIcon, CdkScrollable, MatDialogContent, MatSelect, FormsModule, MatInput, MatOption],
    schemas: [NO_ERRORS_SCHEMA],
})
export class ShareGroupComponent  {
  public sharedusers: any = [];
  public delegateUsers: any = [];
  transferUser: any = [];
  selectedPersons: any = [];
  public msfilter: any;
  people: any = [];
  anyChangeInData: boolean = false;
  selectedGloablAppCode: any;
  selectedgroupapplist: any;
  shareOrTransferResVar:any;
  groupname: any;
  author: any;
  RowID: any;
  title: any;
  constructor(private router: Router,private AppViewService: AppViewService,private capabilityService: CommonModelService,public datepipe: DatePipe, @Inject(MAT_DIALOG_DATA) data,public dialog: MatDialogRef<ShareGroupComponent>,private ngmodel:NgModel) {
    this.selectedGloablAppCode = data.GLOBAL_APP_ID;
    this.selectedgroupapplist = data.LONG_APP_NAME;
    this.groupname = data.groupname;
    this.author = data.author;
    this.RowID = data.id;
    this.title = data.title;
    this.getGroups();   
   }

  closePopup() {
    this.dialog.close(this.anyChangeInData);
    this.router.navigate([{ outlets: { primary: 'maintenance/group' } }]);
  }

  public loadPeople() {
    if (this.msfilter.length >= 4) {
      this.capabilityService.getLDAPUsers(this.msfilter).subscribe(dataStream => {
        this.people = dataStream;
      });
    }
  }
  public addPeople(event) {
    this.selectedPersons = event.value;
    if(event.value.length === 0){
      alert("Please select the user!");
     } else {
      if(this.title === 'Transfer' && event.value.length > 1){
        alert("Groups can be transfer to max 1 user");
        this.closePopup();
      } else if(this.title === 'Transfer'){
        this.transferUser = event.value;
      } else if(this.sharedusers.length <= 9){
        event.value.forEach(item => {
          if (Array.isArray(item)) {
            item.forEach(arr => {
              if (this.sharedusers.indexOf(arr) == -1) {
                this.sharedusers.push(arr);
              }
            });
          } else {
            if (this.sharedusers.indexOf(item) == -1) this.sharedusers.push(item);
          }
        });
      } else {
        alert("Groups can be shared with max 9 users");
      }
     }
    
  }

  getGroups() {
    const data = {
      Group_Key: this.RowID
    };
   this.AppViewService.getgroup(JSON.stringify(data)).subscribe((res: any) => {
      this.selectedgroupapplist = res[0].applications.map(x=>x.LONG_APP_NAME);
      this.selectedGloablAppCode = res[0].applications.map(x=>x.ASK_GLOBAL_ID);
      this.sharedusers = res[0].Sub_Author ? res[0].Sub_Author.split(',') : [];
      this.delegateUsers = res[0].delgates ? res[0].delgates.split(',') : [];
    }, (err) => {
      console.log(err);
    });

  }

  shareOrTransfer(){
   let data = {};
    if(this.selectedPersons.length === 0){
      alert("Please select user!");
      return;
    }
    if(this.sharedusers.length <= 9){
      if(this.title === "Share"){
         data = {
          updated_at: this.datepipe.transform(Date(), 'dd MMM yy hh:mma'),
          author: this.author
        };
        if (this.sharedusers.length > 0) {
          const subauthor = this.sharedusers;
          data['Sub_author'] = subauthor.join(',');
        } else {
          data['Sub_author'] = '';
        }
      } else if(this.title === "Transfer"){
         data = {};
        if (this.transferUser.length > 0) {
          const subauthor = this.transferUser;
          for (let i = 0, len = this.transferUser.length; i < len; i++) {
            const sharedItemIndex = this.sharedusers.findIndex(b => b === this.transferUser[i]);
            this.sharedusers.splice(sharedItemIndex, 1);
          }
          for (let i = 0; i < this.transferUser.length; i++) {
            const delegateItemIndex = this.delegateUsers.findIndex(x => x === this.transferUser[i]);
            this.delegateUsers.splice(delegateItemIndex, 1);
          }
          data['author'] = subauthor.join(',');
          data['Sub_author'] = this.sharedusers.length == 0 ? null : this.sharedusers.join(',');
          data['Delegated_Users'] = this.delegateUsers.length == 0 ? null : this.delegateUsers.join(',');
        } else {
          data['author'] = '';
        }
      }

      const ServicePromise = this.AppViewService.updategroup(JSON.stringify(data), this.RowID);
      ServicePromise.then(res => {
       this.shareOrTransferResVar = res;
       this.anyChangeInData = true;
       this.closePopup();
      }).catch(err => {
        console.log(err);
        this.closePopup();
      });
    } else {
      this.closePopup();
      alert("Groups can be shared with max 9 users");
    }

  }
  resetValue(){
    this.msfilter="";
    this.ngmodel.reset(this.msfilter);
  }
}
